import React, { Component } from 'react'
import './index.css'
import IconClose from "../IconClose";
import { LUCKET_DETAILS_BACKGROUND_COLOR, timeframeOptions } from '../../constants';
import { connect } from "react-redux";
import { setStepMenuOpen, setTimeFrameMenuOpen, selectTimeFrameMenuOpen } from '../../slice/buckets';

class LucketTimeFrameIcon extends Component {

    edit = () => {
        if (this.props.timeFrameMenuOpen === false) {
            this.props.setTimeFrameMenuOpen(true);
            this.props.setStepMenuOpen(false);
        } else {
            this.props.setTimeFrameMenuOpen(false);
        }
    }

    set = (event, v) => {
        event.stopPropagation();
        this.props.setTimeFrameMenuOpen(false);
        this.props.setTimeFrame(v);
    }

    render() {

        return (
            <div className="LucketTimeFrameIcon"
                style={{ borderColor: LUCKET_DETAILS_BACKGROUND_COLOR }}
                onClick={this.edit}>
                {this.props.timeFrame}
                {(this.props.timeFrameMenuOpen === true) ?
                    <div className="timeframe-menu-container">
                        <div className="TimeFrameCallout" />
                        <div id="menu" className="TimeFrameMenu">
                            {timeframeOptions.filter(
                                o => o !== this.props.timeFrame
                            ).map(o =>
                                <div className="LucketTimeFrameIconShort"
                                    key={o}
                                    onClick={(e) => this.set(e, o)}>
                                    <span className="timeframe-option-text">{o}</span>
                                </div>
                            )}
                            <div className="timeframe-menu-close">
                                <IconClose edit={this.edit} key={"close"} />
                            </div>
                        </div></div> : null}
            </div>)
    }

}

const mapStateToProps = (state) => ({
    timeFrameMenuOpen: selectTimeFrameMenuOpen(state)
});

const mapDispatchToProps = {
    setTimeFrameMenuOpen,
    setStepMenuOpen
};

export default connect(mapStateToProps, mapDispatchToProps)(LucketTimeFrameIcon);